import { List, Map, Record } from '@gonfalon/immutable-shim/immutableShim';

import type { AllCodeRefStats, RepoStats } from '#utils/codeRefs/types';

class RepoStatsRecord extends Record<RepoStats>({
  _links: Map({
    self: { self: { href: '', type: '' } },
  }),
  defaultBranch: '',
  enabled: false,
  name: '',
  sourceLink: 'string',
  version: 0,
  fileCount: 0,
  hunkCount: 0,
}) {}

const createRepoStatsRecord = (props = {}) => (props instanceof RepoStatsRecord ? props : new RepoStatsRecord(props));

class AllCodeRefStatsRecord extends Record<AllCodeRefStats>({
  _links: Map({ self: { href: '', type: '' } }),
  items: List(),
}) {}

export const createAllCodeRefStatsRecord = (props = {}) => {
  if (props instanceof AllCodeRefStatsRecord) {
    return props;
  } else {
    const result = new AllCodeRefStatsRecord(props);
    return result.withMutations((f) => {
      f.update('items', (vs) => vs.map(createRepoStatsRecord));
    });
  }
};
